<template>
	<div class="cont-main">
		<div class="text-left mirror-container">
			<codemirror v-model="content" :options="options"></codemirror>
		</div>
		<div class="text-center operate" >
			<el-button type="primary" @click="writeConfirm">确认修改</el-button>
			<el-button type="warning" @click="turnBack()">取消修改</el-button>
		</div>
	</div>
</template>
<script>
import { codemirror } from 'vue-codemirror';
// 核心样式
import 'codemirror/lib/codemirror.css';
// 引入主题后还需要在 options 中指定主题才会生效
import 'codemirror/theme/panda-syntax.css';
import 'codemirror/mode/python/python.js';
export default {
	name: '',
	components: {
		codemirror
	},
	data() {
		return {
			filepath: '',
			content: '', // 编辑器绑定的值
			// 默认配置
			options: {
				tabSize: 2, // 缩进格式
				theme: 'panda-syntax', // 主题，对应主题库 JS 需要提前引入
				lineNumbers: true, // 显示行号
				line: true,
				styleActiveLine: true, // 高亮选中行
				hintOptions: {
					completeSingle: true // 当匹配只有一项的时候是否自动补全
				}
			}
		};
	},
	mounted() {
		this.filepath = this.$route.query.filepath;
		console.log(this.filepath);
		this.getFileContent();
	},
	methods: {
		getFileContent() {
			this.$axios({
				url: this.HOST + '/admin.files/openFile',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					filepath: this.filepath
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
						this.content = res.data.info;
					}
				})
				.catch(err => {});
		},
		writeConfirm(){
			this.$axios({
				url: this.HOST + '/admin.files/reWriteFile',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					filepath: this.filepath,
					content:this.content
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.$message.success(res.data.msg);
					}
				})
				.catch(err => {});
		}
	}
};
</script>
<style lang="scss">
	.cont-main{
		box-sizing: border-box;
		padding-left: 20px;
		overflow-x: hidden;
		.CodeMirror {
			height: 600px;
		}
		.operate{
			margin-top: 60px;
		}
	}
	
</style>
